import { NgModule } from '@angular/core';
import { AccumulatorGridComponent } from './accumulator-grid.component';
import { SharedModule } from '../shared.module';

@NgModule({
  imports: [
    SharedModule
  ],
  declarations: [
    AccumulatorGridComponent
  ],
  exports: [
    AccumulatorGridComponent
  ]
})
export class AccumulatorGridModule { }
